import React from 'react';
import {
    Cell,
    Grid,
    H2,
} from '@saladbob/sassafras'

import Game from './Game';
import ByGame from './ByGame';

import style from './bracket.module.css';

import { Game as GameType } from '../../types'

type Props = {
    games: GameType[],
    tbGames: GameType[],
};

const rows = 52;

const Bracket14: React.FC<Props> = ({games, tbGames}) => {
    return (
        <div style={{ height: '100%', minWidth: 1124 }}>
            <Grid columns="repeat(7, 1fr)">
                {/* Round 1 */}
                <Grid rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '3 / 5' }}>
                        <Game game={games[0]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '7 / 9' }}>
                        <Game game={games[1]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '11 / 13' }}>
                        <Game game={games[2]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '15 / 17' }}>
                        <Game game={games[3]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '19 / 21' }}>
                        <Game game={games[4]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '23 / 25' }}>
                        <Game game={games[5]} topLabel bottomLabel />
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '35 / 36' }} ps="md">
                        <H2 font="leader" className={style.bracketHeading} color="primary">LOSERS BRACKET</H2>
                    </Cell>

                    <Cell style={{ gridRow: '37 / 39' }}>
                        <Game game={games[10]} topLabel bottomLabel/>
                    </Cell>

                    <Cell style={{ gridRow: '41 / 43' }}>
                        <Game game={games[11]} topLabel bottomLabel />
                    </Cell>

                    <Cell style={{ gridRow: '45 / 47' }}>
                        <Game game={games[12]} topLabel bottomLabel />
                    </Cell>

                    <Cell style={{ gridRow: '49 / 51' }}>
                        <Game game={games[13]} topLabel bottomLabel />
                    </Cell>
                </Grid>
                {/* Round 2 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '1 / 4' }}>
                        <Game game={games[6]} topLabel />
                    </Cell>
                    <Cell style={{ gridRow: '8 / 12' }}>
                        <Game game={games[7]}  />
                    </Cell>
                    <Cell style={{ gridRow: '16 / 20' }}>
                        <Game game={games[8]}  />
                    </Cell>
                    <Cell style={{ gridRow: '24 / 27' }}>
                        <Game game={games[9]} bottomLabel />
                    </Cell>

                    {/* Toilet Bowl Heading */}

                    <Cell style={{ gridRow: '29 / 35' }} align="center" justify="flex-end" pe="md">
                        <H2 font="leader" className={style.bracketHeading} color="primary">TOILET BOWL BRACKET</H2>
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '38 / 40' }}>
                        <Game game={games[14]} bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '42 / 44' }}>
                        <Game game={games[15]} bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '46 / 48' }}>
                        <Game game={games[18]} bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '50 / 52' }}>
                        <Game game={games[19]} bottomLabel />
                    </Cell>
                </Grid>
                {/* Round 3 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '2 / 10' }}>
                        <Game game={games[16]} />
                    </Cell>
                    <Cell style={{ gridRow: '18 / 26' }}>
                        <Game game={games[17]} />
                    </Cell>

                    {/* Toilet Bowl */}

                    <Cell style={{ gridRow: '29 / 31' }} bgColor="tertiary200">
                        <Game game={tbGames[0]} bottomLabel topLabel />
                    </Cell>

                    <Cell style={{ gridRow: '31 / 33' }} bgColor="tertiary200" />

                    <Cell style={{ gridRow: '33 / 35' }} bgColor="tertiary200">
                        <Game game={tbGames[1]} topLabel bottomLabel />
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '39 / 43' }}>
                        <Game game={games[20]}  />
                    </Cell>
                    <Cell style={{ gridRow: '47 / 51' }}>
                        <Game game={games[21]} />
                    </Cell>
                </Grid>
                {/* Round 4 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '6 / 22' }}>
                        <Game game={games[22]} />
                    </Cell>

                    {/* Toilet Bowl */}

                    <Cell style={{ gridRow: '29 / 30' }} bgColor="tertiary200" />

                    <Cell style={{ gridRow: '30 / 34' }} bgColor="tertiary200">
                        <Game game={tbGames[2]} />
                    </Cell>

                    <Cell style={{ gridRow: '34 / 35' }} bgColor="tertiary200" />

                    {/* Losers */}

                    <Cell style={{ gridRow: '41 / 49' }}>
                        <Game game={games[23]} />
                    </Cell>
                </Grid>

                {/* Round 5 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '14 / 14' }}>
                        <ByGame />
                    </Cell>

                    {/* TB Winner */}


                    <Cell style={{ gridRow: '29 / 32' }} bgColor="tertiary200" width="100px"/>

                    <Cell style={{ gridRow: '32 / 32' }} bgColor="tertiary200" width="100px">
                        <ByGame tb color="black" />
                    </Cell>

                    <Cell style={{ gridRow: '33 / 35' }} bgColor="tertiary200" width="100px" />

                    {/* Losers */}

                    <Cell style={{ gridRow: '45 / 51' }}>
                        <Game game={games[24]}
                            bottomLabel
                            trophy='trophy'
                            trophyColor={['#A05822', 'white']}
                        />
                    </Cell>
                </Grid>
                {/* Round 6 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '14 / 48' }}>
                        <Game game={games[25]} />
                    </Cell>
                </Grid>
                {/* Round 7 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`} className={`${style.championship} ${style.printOnly}`}>
                    <Cell style={{ gridRow: '31 / 33' }} width="100px">
                        <ByGame trophy loserTrophy />
                    </Cell>
                    <Cell style={{ gridRow: '33 / 35' }}>
                        <Game game={games[26]} />
                    </Cell>
                </Grid>

                {games[25].winner && games[25].team2.id === games[25].winner.id && (
                    <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`} className={`${style.championship} ${style.screenOnly}`}>
                        <Cell style={{ gridRow: '20 / 42' }} width="260px">
                            <Game game={games[26]} />
                        </Cell>
                    </Grid>
                )}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`} className={`${style.championship} ${style.screenOnly}`}>
                    <Cell style={{ gridRow: '31 / 33' }} width="100px">
                        <ByGame trophy loserTrophy />
                    </Cell>
                </Grid>
            </Grid>
        </div>
    );
}

export default Bracket14;
